import { Transform } from 'class-transformer';

import { booleanTransform } from '../utils/helper';
import { InsModDate } from './date.model';

export class Tipologiaintervento extends InsModDate {
	id!: number;
	tipologiaservizioid!: number;
	type!: string; // nome tipologia servizio
	name!: string; // ex descrizione
	tariffazioneid!: number;
	lungapercorrenzaid!: number;
	sostaid!: number;
	ttcode!: string;
	ttpcode!: string;
	ttcocode!: string;
	color!: string;
	@Transform(booleanTransform)
	utfflag!: number;
}